import React, { useCallback, useEffect, useState } from 'react';
import '../assets/css/OtaDashboard.css';
import { getAllDeviceStatus } from '../commonApi';
import { toast } from 'react-toastify';
import { useParams, useNavigate } from 'react-router-dom';
import arrowBackImg from '../assets/images/arrow_back.svg';
import DashboardChart from '../components/DashboardChart';
import DashboardCard from '../components/DashboardCard';

function OtaDashboard() {
  const navigate = useNavigate();
  const { jobId } = useParams();
  const [data, setData] = useState({
    chartData: [],
    cardData: [],
  });
  const [noDevicesMessage, setNoDevicesMessage] = useState(null); // New state for no-devices message

  const chartType = "doughnut";
  const chartTitle = "Job Id : " + jobId;
  const chartLabel = "Job Status Count";
  const chartBackgroundColor = [
    'rgba(255, 99, 132, 0.6)',
    'rgba(54, 162, 235, 0.6)',
    'rgba(255, 206, 86, 0.6)',
    'rgba(75, 192, 192, 0.6)',
    'rgba(153, 102, 255, 0.6)',
  ];
  const chartBorderColor = [
    'rgba(255, 99, 132, 1)',
    'rgba(54, 162, 235, 1)',
    'rgba(255, 206, 86, 1)',
    'rgba(75, 192, 192, 1)',
    'rgba(153, 102, 255, 1)',
  ];
  const chartBorderWidth = 1;

  const fetchIotJobsDetails = useCallback(async () => {
    try {
      const response = await getAllDeviceStatus(jobId);
      // Check if there are no devices in the IoT job
      if (!response.data.things || response.data.things.length === 0) {
        setNoDevicesMessage("No devices are associated with this IoT job.");
        setData({ chartData: [], cardData: [] }); // Clear chart/card data
        return;
      }

      // Process data if devices are present
      const jobStatusCountMap = response.data.things.reduce((acc, thing) => {
        const jobStatus = thing.jobStatus;
        acc[jobStatus] = acc[jobStatus] ? acc[jobStatus] + 1 : 1;
        return acc;
      }, {});

      const chartDataFormatted = Object.keys(jobStatusCountMap).map(status => ({
        label: status,
        data: jobStatusCountMap[status],
      }));

      const cardDataFormatted = Object.keys(jobStatusCountMap).map(status => ({
        id: status,
        title: `${status}`,
        content: `${jobStatusCountMap[status]}`,
      }));

      setData({
        chartData: chartDataFormatted,
        cardData: cardDataFormatted,
      });
      setNoDevicesMessage(null); // Clear message if devices are present

    } catch (error) {
      toast.error("Error fetching IoTJobs details!");
      setNoDevicesMessage("Failed to load job details. Please try again later.");
    }
  }, [jobId]);

  const handleBack = () => {
    navigate(-1); // Navigates to the previous page
  };

  useEffect(() => {
    fetchIotJobsDetails();
  }, [jobId, fetchIotJobsDetails]);

  return (
    <div className='custom_form_wrapper' style={{ height: "90%" }}>
      <div className="custom_form_header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <p className="form_head_title">Dashboard</p>
        <div className="action_cta">
          <button className="btn page_back_btn" onClick={handleBack}>
            <img src={arrowBackImg} alt="Arrow-back" height="16" width="16" />
            Back
          </button>
        </div>
      </div>
      <div
        className="modal fade discard_modal"
        id="delete-model"
        aria-hidden="true"
        aria-labelledby="exampleModalToggleLabel"
        tabIndex="-1"
      ></div>
      {noDevicesMessage && (
        <div className="no-devices-message">
          <p>{noDevicesMessage}</p>
        </div>
      )}
      <div className='firmware-dashboard'>
        {!noDevicesMessage && (
          <>
            <div className='left-card'>
              <DashboardChart type={chartType} textTitle={chartTitle} chartData={data.chartData} label={chartLabel} backgroundColor={chartBackgroundColor} borderColor={chartBorderColor} borderWidth={chartBorderWidth} height="inherit" width="inherit"/>
            </div>
            <div className='right-card'>
              {data.cardData.map((card) => (
                <DashboardCard key={card.id} title={card.title} content={card.content} />
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default OtaDashboard;